import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { productsPrefetchHandlers } from '@/utils/prefetchProductsRoute';
import { useAuth } from '@/hooks/auth';
import FooterNewsletterSection from './FooterNewsletterSection';
import FooterSupplierLogos from './FooterSupplierLogos';

import FooterDropdownSection from './FooterDropdownSection';
const Footer = () => {
  const { isAdmin, isSuperAdmin } = useAuth();
  return <footer className="bg-gradient-green text-white" style={{ minHeight: '600px' }}>
      <FooterNewsletterSection />
      
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <FooterDropdownSection title="Koöperasie Veevoer Winkel">
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <div>
                  <div>Plot 365, cnr R104 (Old Bronkhortspruit Road) and R964</div>
                  <div>(Donkerhoek road), Donkerhoek, Pretoria East, 0185</div>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} />
                <span>061 321 5050</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={16} />
                <span>info@veevoerwinkel.co.za</span>
              </div>
              <div className="flex items-start space-x-2">
                <Clock size={16} className="mt-1 flex-shrink-0" />
                <div>
                  <div>Mon-Fri: 8:00 AM - 5:00 PM</div>
                  <div>Sat: 8:00 AM - 1:00 PM</div>
                  <div>Sun: Closed</div>
                  <div>Public Holidays: 8:00 AM - 1:00 PM</div>
                  <div className="text-xs">(Closed on Christian Holidays)</div>
                  <div className="text-xs font-medium mt-1">
                    *No deliveries over weekends and on Public Holidays
                  </div>
                </div>
              </div>
            </div>
          </FooterDropdownSection>

          {/* Quick Links */}
          <FooterDropdownSection title="Quick Links">
            <ul className="space-y-2 text-sm">
              <li><Link to="/products" {...productsPrefetchHandlers} className="hover:text-gold-400 transition-colors">All Products</Link></li>
              <li><Link to="/products?category=animal-feed" className="hover:text-gold-400 transition-colors">Animal Feed Products</Link></li>
              <li><Link to="/products?category=pet-supplies" className="hover:text-gold-400 transition-colors">Pet Supplies & Food</Link></li>
              <li><Link to="/products?category=farm-hardware-and-tools" className="hover:text-gold-400 transition-colors">Farm Hardware & Tools</Link></li>
              <li><Link to="/blog" className="hover:text-gold-400 transition-colors">Blog & Articles</Link></li>
            </ul>
          </FooterDropdownSection>

          {/* Customer Service */}
          <FooterDropdownSection title="Customer Service">
            <ul className="space-y-2 text-sm">
              <li><Link to="/policies" className="hover:text-gold-400 transition-colors">Company Policies</Link></li>
              <li><Link to="/policy/shipping-delivery-policy" className="hover:text-gold-400 transition-colors">Shipping Information</Link></li>
              <li><Link to="/policy/return-refund-policy" className="hover:text-gold-400 transition-colors">Returns & Refunds</Link></li>
              <li><Link to="/policy/terms-and-conditions" className="hover:text-gold-400 transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/policy/privacy-policy" className="hover:text-gold-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/contact" className="hover:text-gold-400 transition-colors">Contact Support</Link></li>
              {(isAdmin || isSuperAdmin) && (
                <li><Link to="/test-delivery" className="hover:text-gold-400 transition-colors">🧪 Delivery Test</Link></li>
              )}
            </ul>
          </FooterDropdownSection>

          {/* About */}
          <FooterDropdownSection title="About Us">
            <p className="text-sm text-gray-300 mb-4">
              Your trusted partner for quality animal feed, pet supplies, and farm equipment. 
              Serving the agricultural community with excellence since our establishment.
            </p>
          </FooterDropdownSection>
        </div>
      </div>

      <FooterSupplierLogos />


      {/* Copyright */}
      <div className="border-t border-springbok-700">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-300">
            <div>© {new Date().getFullYear()} <span style={{ color: '#D4AF37', textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)' }}>Koöperasie Veevoer Winkel</span>. All rights reserved.</div>
            <div className="mt-2 md:mt-0">
              Powered by <span className="text-springbok-300">Veevoer Technology</span>
            </div>
          </div>
          {/* Made with love inscription */}
          <div className="text-center mt-4 pt-4 border-t border-springbok-700/50">
            <span className="inline-block text-gray-300 cursor-default" style={{
            fontFamily: 'Playfair Display, serif'
          }}>
              <span className="text-sm font-light italic">
                Made with <span className="text-red-500 text-base">❤️</span> by A
              </span>
            </span>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;